import { useMemo } from 'react';
import { Role } from 'api/models';
import { Option } from 'components/atoms/select';
import { useVendorRolesQuery } from 'queries/roles';

interface Result {
  roles: Role[];
  roleOptions: Option[];
}
export const useRolesOptionsForPartnerMembers = (): Result => {
  const { data: roles } = useVendorRolesQuery();
  const rolesForPartners = useMemo(
    () => (roles ?? []).filter(({ usedByPartners }) => usedByPartners === true),
    [roles],
  );
  const roleOptions = useMemo(
    () =>
      rolesForPartners.map(({ roleName, roleId }) => ({
        label: roleName,
        value: roleId,
      })),
    [rolesForPartners],
  );

  return {
    roles: rolesForPartners,
    roleOptions,
  };
};
